import { Component, inject, OnInit } from '@angular/core';
import { StandardSimpleModalWrapperComponent, BsCommon } from '@bsquare/angular-common';
import { take } from 'rxjs/operators';
import { VersionService } from 'services/version.service';

@Component({
  selector: 'app-about-modal-component',
  templateUrl: './about-modal.component.html',
  styleUrls: ['./about-modal.component.scss'],
  imports: [BsCommon],
})
export class AboutModalComponent
  extends StandardSimpleModalWrapperComponent<void, void>
  implements OnInit
{
  private readonly versionService = inject(VersionService);

  public versions: string[][] = [];

  public ngOnInit(): void {
    this.versionService.version.pipe(take(1)).subscribe((version) => {
      const splitVersions = version.split(',');
      for (const service of splitVersions) {
        if (service.startsWith('latest')) {
          this.versions.push([service]);
        } else {
          this.versions.push(service.split(':'));
        }
      }
    });
  }

  protected getApproveData(): void {
    // Deliberately empty
  }
}
